import localforage from 'localforage';

// This function is to migrate persisted data from LocalStorage to IndexedDB
// Even though we try to copy this is still going to log the user out (only this one time as it clears localStorage)
// Only one key should be left in localStorage, HasAcceptedTermsAndConditions
export async function migrateLocalStorageToIndexedDb()
{
	// Collect all of the keys so that we do not attempt to modifty the localStorage in the middle of iteration
	const keysToMigrate: string[] = [];

	// Collect all persist:* keys first
	for (let i = 0; i < localStorage.length; i++)
	{
		const key = localStorage.key(i);
		if (key && key.startsWith('persist:'))
		{
			keysToMigrate.push(key);
		}
	}

	// Now safely iterate over collected keys -- this is going to log the user out
	for (const key of keysToMigrate)
	{
		const stringValue = localStorage.getItem(key);
		if (stringValue)
		{
			try
			{
				const parsedValue = JSON.parse(stringValue);
				await localforage.setItem(key, parsedValue);
				console.log(`[migration] Migrated ${key}`);
			}
			catch (err)
			{
				console.warn(`[migration] Failed to parse ${key}:`, err);
			}
		}

		localStorage.removeItem(key);
	}
}